var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.linkType !== 'custom')?_c('router-link',{ref:"link",class:_vm.classname,attrs:{"to":_vm.linkUrl,"target":_vm.target,"title":_vm.title,"exact":_vm.exact}},[_vm._t("default")],2):_c('a',{ref:"link",class:_vm.classname,attrs:{"href":_vm.linkUrl,"target":_vm.target,"title":_vm.title}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }